<template>
  <div class="animated fadeIn">
    <div v-if="$route.name == 'CorrespondenceList'" class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-align-justify" /> Correspondence
            <router-link
              v-if="$_allowCreating"
              :to="'/admin/content/correspondence/new'"
              class="pull-right btn btn-success btn-sm"
              exact
            >
              New
            </router-link>
            <button
              v-if="allowSearchAdministration"
              class="add-to-index-all btn btn-primary btn-sm pull-right"
              @click="$_addToIndexAll('correspondence')"
            >
              Add all to search index <span class="btn-loader" style="display: none;" />
            </button>
            <button
              v-if="allowRegenerateThumbs"
              class="regenerate-thumbs btn btn-primary btn-sm pull-right"
              @click="$_regenerateThumbs('correspondence', 'Correspondence')"
            >
              Regenerate thumbnails <span class="btn-loader" style="display: none;" />
            </button>
          </div>

          <div class="card-block">
            <input
              v-model="searchQuery"
              type="text"
              class="form-control"
              placeholder="Search by correspondence title"
            >

            <div class="mt-10">
              <label>Filter by type:</label>
              <select
                v-model="filterChoosenCorrType"
                class="form-control"
                style="display: inline-block; width: auto;"
                @change="changeFilterChoosenCorrType"
              >
                <option value="">-all-</option>
                <option v-for="item in corrTypes" :key="item" :value="item">{{ parsedCorrType(item) }}</option>
              </select>
            </div>
          </div>

          <div v-if="allowPublishing" class="card-block">
            <h6 class="card-title">Publish/Unpublish by correspondence type</h6>

            <select v-model="publishChoosenCorrType" class="form-control" style="display: inline-block; width: auto;">
              <option v-for="item in corrTypes" :key="item" :value="item">{{ parsedCorrType(item) }}</option>
            </select>

            <button class="btn btn-primary btn-sm" @click="changeCorrTypePublished(true)">
              Publish
              <span ref="publishGroupLoader" class="btn-loader" style="display: none;" />
            </button>
            <button class="btn btn-primary btn-sm" @click="changeCorrTypePublished(false)">
              Unpublish
              <span ref="unpublishGroupLoader" class="btn-loader" style="display: none;" />
            </button>
          </div>

          <EmptyBtns
            :empty-search="emptySearch"
            @showEmpty="() => emptySearch = true"
            @showAll="() => emptySearch = false"
          />

          <BulkBtns
            :class="{ hidden: !choosenEntities.length }"
            entity-type="correspondence"
            unpublish-empty-endpoint="correspondence/unpublish-empty"
            :choosen-entities="choosenEntities"
            :show-index-btn="true"
            @changePublishedBtns="$_changePublishedBtns"
            @clearChoosenEntities="() => choosenEntities = []"
          />

          <div class="card-block spinner-parent">
            <spinner ref="spinner" size="md" text="Loading ..." />

            <nav>
              <pager
                :total="total"
                :offset="offset"
                :size="perPage"
                @page-changed="$_changePage"
              />
            </nav>
            <div class="table-responsive">
              <table v-if="total" class="entities table table-bordered table-striped table-sm">
                <thead>
                  <tr>
                    <th class="table-list__cell--narrow">
                      <input ref="allEntities" type="checkbox" @change="$_selectAllEntities">
                    </th>
                    <th>ID</th>
                    <th>Thumbnail</th>
                    <th class="table-list__cell--narrow">Title</th>
                    <th>Type</th>
                    <th>Date</th>
                    <th>Actions</th>
                    <th>Included in Picks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in entities" :key="item.id" :data-id="item.id">
                    <td class="table-list__cell--narrow text-center">
                      <input v-model="choosenEntities" type="checkbox" :value="item.id">
                    </td>
                    <td>{{ item.id }}</td>
                    <td class="table-list__cell--narrow text-center">
                      <img :src="validateUrl(item.thumbnail)" alt="" style="max-height: 100px;">
                    </td>
                    <td>{{ item.title }}</td>
                    <td>{{ item.type }}</td>
                    <td>{{ item.date }}</td>
                    <td class="table-list__cell--narrow">
                      <div>
                        <button
                          v-if="allowSearchAdministration"
                          class="add-to-index-single btn btn-primary btn-sm"
                          @click="$_addToIndexSingle('correspondence', item.id)"
                        >
                          Add to index <span class="btn-loader" style="display: none;" />
                        </button>
                        <router-link
                          v-if="$_allowUpdating(item)"
                          class="btn btn-primary btn-sm"
                          :to="{ name: 'CorrespondenceEdit', params: { id: item.id }}"
                        >
                          Edit
                        </router-link>
                        <button
                          v-if="allowPublishing"
                          class="btn btn-primary btn-sm"
                          @click="$_changePublished(item.published, 'correspondence', item.id)"
                        >
                          <template v-if="item.published">Unpublish</template>
                          <template v-else>Publish</template>
                          <span :ref="`publishBtnLoader_${item.id}`" class="btn-loader" style="display: none;" />
                        </button>
                        <button
                          class="btn btn-primary btn-sm"
                          @click="$_regThumb(item, 'correspondence', 'Correspondence')"
                        >
                          Reg. thumb
                          <span :ref="`_regThumbBtnLoader_${item.id}`" class="btn-loader" style="display: none;" />
                        </button>
                      </div>
                      <div class="mt_4">
                        <button
                          v-if="$_allowDeleting(item)"
                          class="btn btn-danger btn-sm"
                          @click="$_deleteEntity(item, 'correspondence/', 'Correspondence')"
                        >
                          Delete
                          <span :ref="`deleteBtnLoader_${item.id}`" class="btn-loader" style="display: none;" />
                        </button>
                        <open-on-site
                          :source-route="item.route"
                        />
                      </div>
                    </td>
                    <td class="table-list__cell--narrow text-center">
                      <input v-if="item.included_in_picks" type="checkbox" :value="item.id" @change="$_sendPicks($event, item.id, 'correspondence')" class="add-to-picks" checked>
                      <input v-else type="checkbox" :value="item.id" @change="$_sendPicks($event, item.id, 'correspondence')" class="add-to-picks">
                      <span :ref="`pickBtnLoader_${item.id}`"  class="btn-loader" style="display: none;" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div v-if="total === 0">There are no entities for your request</div>

            <nav>
              <pager
                :total="total"
                :offset="offset"
                :size="perPage"
                @page-changed="$_changePage"
              />
            </nav>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Pager from '@/global/components/Pager';
import BulkBtns from '@/global/components/BulkBtns';
import EmptyBtns from '@/global/components/EmptyBtns';
import OpenOnSiteButton from '@/global/components/OpenOnSiteButton';
// Mixins
import ListPageMixin from '@/mixins/ListPageMixin';
import CommonPageMixin from '@/mixins/CommonPageMixin';

export default {
  name: 'CorrespondenceList',

  components: {
    pager: Pager,
    BulkBtns,
    EmptyBtns,
    'open-on-site': OpenOnSiteButton,
  },

  mixins: [ListPageMixin, CommonPageMixin],

  data: () => ({
    publishChoosenCorrType: 'je_white_letters',
    filterChoosenCorrType: '',
  }),

  computed: {
    corrTypes() {
      return this.$store.state.corrTypes.list;
    },
  },

  methods: {
    validateUrl(url) {
      if (url.indexOf('://') !== -1) {
        return url;
      }
      return this.$config.app_api.host + url;
    },
    changeCorrTypePublished(published) {
      if (window.confirm('Are you sure?')) {
        const $loader = published ? $(this.$refs.publishGroupLoader) : $(this.$refs.unpublishGroupLoader);
        $loader.show();
        this.$apiHttp.post(`${this.$config.app_api.prefix}correspondence/change-publishing-status`, {
          status: published ? 1 : 0,
          type: this.publishChoosenCorrType,
        }).then(() => {
          $loader.hide();
        }).catch((error) => {
          $loader.hide();
          console.error('Error in publishing/unpublishing corr type', error);
        });
      }
    },
    changeFilterChoosenCorrType() {
      this.offset = 0;
      this.getSource();
    },
    getSource() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      const searchString = encodeURI(this.searchQuery);
      const page = this.perPage ? (this.offset / this.perPage + 1) : 1;
      const searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(`${this.$config.app_api.prefix}correspondence${this.emptySearch ? '/show-empty' : ''}`, {
        params: {
          search_string: searchString,
          page,
          type: this.filterChoosenCorrType ? this.filterChoosenCorrType : '',
        },
      }).then((response) => {
        if (this.searchProcessId === searchProcessId) {
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
          this.total = response.data.meta.pagination.total;
          this.perPage = response.data.meta.pagination.per_page;

          const correspondenceArr = _.cloneDeep(response.data);
          delete correspondenceArr.meta;
          this.entities = Object.keys(correspondenceArr).map(e => correspondenceArr[e]);
        }
      }).catch((error) => { this.$_errorCallback(error); });
    },
    parsedCorrType(str) {
      return str.replace(/_/g, ' ');
    },
  },
};
</script>



// WEBPACK FOOTER //
// Index.vue?325e1c00